// extracted by mini-css-extract-plugin
export default {"clampContainer":"clampContainer---yi4oV","title":"title---_qqeu"};